import {GlobalVariables} from "../GlobalVariables";
export default class BlockAnchor {
	static init() {

		const hash = window.location.hash.substring(1);
		this.scrollToHash(hash);
		// this.fixHashClicksWhileScrolling();

	}

	static scrollToHash(hash) {
		if (hash) {
			const target = document.querySelector(`#${hash}`);
			if (target) {

				if (GlobalVariables.lenis !== null) {
					setTimeout(() => {
						GlobalVariables.lenis.scrollTo(target, true);
					}, 500);
				} else {
					setTimeout(() => {
						target.scrollIntoView({
							behavior: "smooth",
							block: "start",
						});
					}, 500);
				}

			}
		}
	}

	// static fixHashClicksWhileScrolling() {
	// 	let isScrolling = false;
	// 	let timeout;
	//
	// 	if (GlobalVariables.lenis !== null) {
	// 		GlobalVariables.lenis.on('scroll', () => {
	// 			isScrolling = true;
	// 			clearTimeout(timeout);
	// 			timeout = setTimeout(() => isScrolling = false, 200);
	// 		});
	//
	// 		document.querySelectorAll('a[href^="#"]:not([href="#"]').forEach(link => {
	// 			link.addEventListener('click', (event) => {
	// 				if (isScrolling) {
	// 					event.preventDefault();
	// 					GlobalVariables.lenis.scrollTo(
	// 						document.querySelector(link.getAttribute('href')),
	// 						{ duration : 1.5 }
	// 					);
	// 				}
	// 			});
	// 		});
	// 	}
	// }
}
